export default __webpack_public_path__ + "static/media/sally_bell.9ee27b24.jpg";